var image_upload_default = {
  "container": "Tdk42",
  "disabled": "ScO-Y",
  "imageInput": "wO11W",
  "overlay": "GznPB",
  "text": "PmuFD",
  "shown": "jEXS-",
  "hide": "I0QgI",
  "spinner": "cBYlW",
  "spin": "bD8O7"
};
export {
  image_upload_default as default
};
//# sourceMappingURL=image-upload-scss.js.map
